// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container_wallet[data-v-ded506f8]{border-radius:24px;color:#fff;cursor:pointer}.autenticar[data-v-ded506f8]{background:#003b71}.text-autenticar[data-v-ded506f8]{background:#0073ba}.text-wallet[data-v-ded506f8]{border-radius:0 24px 24px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
